import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicGlover from "../Components/ProjPicGlover";

const ProjectPageGlover = () => {
    return (
        <>
            <Navbar />
            <ProjPicGlover />
            <Footer />
        </>
    );
};

export default ProjectPageGlover;
